import Api from '@/api/Api'

const DEFAULTS = {
  image: 100 * 1024 * 1024 * 1024,   // 100 GB
  vector: 500 * 1024 * 1024,        // 500 MB
  table: 500 * 1024 * 1024          // 500 MB
}

export const state = {
  image: null,
  vector: null,
  table: null,
  loaded: false
}

export const getters = {
  maxSizeImage (state) {
    return state.image != null ? state.image : DEFAULTS.image
  },
  maxSizeVector (state) {
    return state.vector != null ? state.vector : DEFAULTS.vector
  },
  maxSizeTable (state) {
    return state.table != null ? state.table : DEFAULTS.table
  },
  uploadLimitsLoaded (state) {
    return state.loaded
  }
}

export const mutations = {
  SET_UPLOAD_LIMITS (state, { image, vector, table }) {
    state.image = image
    state.vector = vector
    state.table = table
    state.loaded = true
  }
}

export const actions = {
  async fetchUploadLimits ({ commit, state }) {
    if (state.loaded) return
    try {
      const res = await Api.getUploadLimits()
      const data = res.data?.data || res.data
      if (data && typeof data.image === 'number' && typeof data.vector === 'number' && typeof data.table === 'number') {
        commit('SET_UPLOAD_LIMITS', {
          image: data.image,
          vector: data.vector,
          table: data.table
        })
      }
    } catch (_) {
      // keep defaults
    }
  }
}



// WEBPACK FOOTER //
// ./src/state/modules/uploadLimits.js